import { useEffect } from 'react';
import { getDesabilitarMenuCookie, getDesabilitarMenuSession } from './shared';

function useIframeResizer() {
  useEffect(() => {
    function sendHeight() {
      const container = document.querySelector('.main-container');

      let height = container
        ? container.scrollHeight
        : document.documentElement.scrollHeight || document.body.scrollHeight;

      window.parent.postMessage({ type: 'iframe-resize', height }, '*');
    }

    if (getDesabilitarMenuSession() || getDesabilitarMenuCookie()) {
      sendHeight();
      const observer = new MutationObserver(sendHeight);
      observer.observe(document.body, { childList: true, subtree: true });

      return () => {
        window.removeEventListener('resize', sendHeight);
        observer.disconnect();
      };
    }
  }, []);
}

export default useIframeResizer;
